export const VENDOR_QUICK_FILTER_SUMMARY_TABS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

export const VENDOR_PAGE_TABS = {
  LIST: 'list'
};
